export default function (_a) {
    var env = _a.env, inputs = _a.inputs, data = _a.data;
    inputs['customResponse'](function (response) {
        var _a, _b;
        env.collect('结束 response: ', response);
        (_b = (_a = env.hooks) === null || _a === void 0 ? void 0 : _a.onFinished) === null || _b === void 0 ? void 0 : _b.call(_a, response, !data.useRegular);
    });
}
